import { render, staticRenderFns } from "./EmailTemplateCategoryList.vue?vue&type=template&id=80057894&"
import script from "./EmailTemplateCategoryList.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports